<template>
    <div class="dtop">
        操作日志
    </div>
    <div class="dseach">
        <div class="dseachs">
            <div style="width: 24px;height: 24px;">
                <img style="width: 100%;height: 100%;" src="../../assets/secree.png" alt="">
             
            </div>
            <div class="search">
                <input v-model="seachkey" type="text" placeholder="关键字搜索" @keyup.enter="seach">
            </div>
        </div>
        <div class="ddata">
            <el-date-picker class="choosedatas" v-model="choosedata" type="daterange" range-separator="-"
                start-placeholder="Start date" end-placeholder="End date" @change="changedata" format="MM.DD" />
        </div>
    </div>
    <div class="riperpo">
        <table>
            <thead>
                <tr style="background-color: #EEEEEE;">
                    <th style="width: 130px;">操作人</th>
                    <th style="width: 130px;">ip地址</th>
                    <th style="width: 196px;">具体时间</th>
                    <th style="width: 196px;">操作类型</th>
                    <th>具体操作</th>
                </tr>
            </thead>
            <tbody v-infinite-scroll="load" :infinite-scroll-immediate="false">
                <tr v-for="(item, index) in pageLoglist" :key="index">
                    <td  style="width: 130px;">
                        <div>{{ item.userName }}</div>

                        <div>ID：{{ item.userId }}</div>
                    </td>
                    <td  style="width: 130px;">
                        <div v-if="!item.occurAddr && !item.occurIp">
                            未知IP
                        </div>
                        <div v-else>
                            <div>{{ item.occurAddr }}</div>

                            <div>{{ item.occurIp }}</div>
                        </div>

                    </td>
                    <td style="width: 196px;">{{ time(item.invokeStartTime) }}</td>
                    <td style="width: 196px;">{{ item.opeType }}</td>
                    <td>{{ item.opeDesc }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import storeapi from '@/api/store'
let current = ref(1)
let pageLoglist = ref([])
let seachkey = ref('')
onMounted(() => {
    pageAdmin()
})
const pageAdmin = async () => {
    try {
        let data = {
            "keyword": seachkey.value,
            "keywordType": 0,
            "page": {
                "current": current.value,
                "pageSize": 5
            }
        }
        const res = await storeapi.pageLog(data)
        console.log(res)
        pageLoglist.value = res.data.records
    } catch (error) {
        console.log(error)

    }
}
const seach = () => {
    current.value = 1
    pageAdmin()
}
const time = (times) => {
    const date = new Date(times);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
}

let nowdata = new Date()
let nextdata = new Date()
const choosedata = ref([nowdata, nextdata])
const changedata = (e) => {
    console.log(choosedata.value)
    console.log(e)
}

const load = async () => {
    console.log(';current', current.value)

    current.value++
    try {
        let data = {
            "keyword": seachkey.value,
            "keywordType": 1,
            "page": {
                "current": current.value,
                "pageSize": 5
            }
        }
        const res = await storeapi.pageLog(data)
        console.log(res)
        pageLoglist.value.push(...res.data.records)
    } catch (error) {
        console.log(error)

    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #F8F8F8 !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

}

::v-deep .choosedatas {
    width: 100%;
    height: 100%;
    background-color: #FAFAFA;
    --el-input-border-color: transparent;


    input {
        font-size: 16px;
        color: #718096;
    }

}

.dtop {
    font-size: 16px;
    font-weight: 400;
    color: #111827;
    height: 27px;
    margin-bottom: 20px;
}

.dseach {
    display: flex;

    .dseachs {
        width: 412px;
        height: 48px;
        background: #F8F8F8;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 8px;
        display: flex;
        padding-left: 20px;
        box-sizing: border-box;
        align-items: center;

        input {
            width: 300px;
            border: none;
            outline: none;
            font-size: 16px;
            background: #FAFAFA;
        }
        ::placeholder {
                font-weight: 400;
                font-size: 14px;
                color: #7D8592;
            }
        .search{
            background: #FAFAFA;

        }
    }

    .ddata {
        width: 172px;
        height: 48px;
        background: #FAFAFA;
        margin-left: 24px;
        border-radius: 8px;

    }

}

tbody {
    display: block;
}
thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}



.riperpo {

    width: 100%;
    margin-top: 21px;
    font-size: 14px;

    table {
        width: 100%;
        // height: 200px;
        // height: 480px;
        // overflow-y: scroll;
        // display: block;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
            width: 100%;

            height: 46px;
            line-height: 46px;
            font-size: 14px;
            font-weight: 400;
            color: #4D585F;

            th:first-child {
                text-align: left;
            }

            th {
                text-align: left;
                background-color: #EEEEEE;

            }

            :first-child {
                padding-left: 24px;
                border-radius: 8px 0 0 8px;
                box-sizing: border-box;

            }

            :last-child {
                border-radius: 0 8px 8px 0;

            }

        }

        tbody {

            width: 100%;
            height: 400px;
            overflow-y: scroll;


            tr {
                width: 100%;
                text-align: center;


                font-weight: 400;
                color: #718096;
                border-bottom: 1px solid #E9E9E9;

                td {
                    height: 87px;
                    box-sizing: border-box;
                    padding-top: 24px;
                    vertical-align: middle;
                    text-align: left;
                }

                // td:last-child {
                //     border-bottom: 1px solid transparent;

                // }

                td:first-child {
                    padding-top: 21px;

                    padding-left: 24px;



                    width: 100px;
                    text-align: left;
                    line-height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.65);

                    div:last-child {
                        margin-top: 6px;
                        color: rgba(0, 0, 0, 0.45);
                        font-weight: 400;
                    }

                }
            }
        }
    }

}
</style>